import React from 'react';
import DetailsTooltip from '../../shared/customMapLayer/DetailsTooltip';
import PropTypes from 'prop-types';
import { faHashtag, faUserTie } from '@fortawesome/free-solid-svg-icons';

function WorklistItemTooltip({ id, name }) {
  return (
    <DetailsTooltip
      details={[
        { icon: faHashtag, value: id },
        { icon: faUserTie, value: name },
      ]}
    />
  );
}

WorklistItemTooltip.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
};

export default React.memo(WorklistItemTooltip);
